// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"b53debc5","769":"74727b47","875":"b37fad64"}[chunkId] + ".chunk.js";
};